import React from 'react';
import SiteHeader from './SiteHeader';
import LogoHeader from './LogoHeader';
import SiteFooter from './SiteFooter';

// The layout shell every screen sits on: a 72px header over the white page, a
// centred content column capped at 1060px, then the site footer. (The one
// warm-grey surface left in the app is CenteredCardTempScreen.)
//
//  - variant="full"    — the shared SiteHeaderView nav (in-app wiring) + SiteFooter. App routes.
//  - variant="minimal" — LogoHeader only, no footer.
export function PageShell({
    variant = 'full',
    children,
}: {
    variant?: 'full' | 'minimal';
    children: React.ReactNode;
}) {
    return (
        <div className="flex min-h-screen flex-col bg-page">
            {variant === 'minimal' ? <LogoHeader /> : <SiteHeader />}
            <main className="mx-auto w-full max-w-content flex-1 px-5 pb-20 pt-[22px] md:px-10 md:pt-[60px]">
                {children}
            </main>
            {variant === 'full' && <SiteFooter />}
        </div>
    );
}

// Desktop two-column body: left column flex:1, right column fixed 360px, 40px
// gap, top-aligned. Collapses to a single column when the summary no longer
// fits (below `lg`).
export function TwoColumn({
    left,
    right,
    className = '',
}: {
    left: React.ReactNode;
    right: React.ReactNode;
    className?: string;
}) {
    return (
        <div className={`flex flex-col items-start gap-10 lg:flex-row ${className}`}>
            <div className="w-full min-w-0 lg:flex-1">{left}</div>
            <div className="w-full flex-none lg:w-[360px]">{right}</div>
        </div>
    );
}

export default PageShell;
